
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO, generateBreadcrumbSchema } from '../../utils/seo';

const PrivacyPage = () => {
  // SEO Configuration
  useSEO({
    title: 'Privacy Policy - PURECODE Ltd',
    description:
      'PURECODE Ltd Privacy Policy. Learn how we collect, use, and protect your personal data in compliance with UK GDPR and Data Protection Act 2018.',
    canonical: 'https://purecode.uk/privacy',
    schema: generateBreadcrumbSchema([
      { name: 'Home', url: '/' },
      { name: 'Privacy Policy', url: '/privacy' },
    ]),
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 via-cyan-600 to-blue-600 text-white py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">
              Privacy Policy
            </h1>
            <p className="text-xl text-teal-100">
              Last updated: {new Date().toLocaleDateString('en-GB')}
            </p>
          </div>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-4xl px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="text-gray-600 mb-6">
              PURECODE Ltd ("we," "our," or "us") is committed to protecting
              your privacy and personal data. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              visit our website or use our services. We comply with the UK
              General Data Protection Regulation (UK GDPR) and the Data
              Protection Act 2018.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              2. Data Controller Information
            </h2>
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <p className="text-gray-700 mb-2">
                <strong>Data Controller:</strong> PURECODE Ltd
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Registered Address:</strong>{' '}
                <a
                  href="https://www.google.com/maps/dir//The+Genesis+Centre,+Birchwood,+Warrington+WA3+7BH,+UK"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal-600 hover:text-teal-800 cursor-pointer transition-colors duration-200 ml-1"
                >
                  The Genesis Centre, Birchwood, Warrington, England, WA3 7BH
                </a>
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Email:</strong>{' '}
                <a
                  href="mailto:hello@purecode.uk"
                  className="text-teal-600 hover:text-teal-800 cursor-pointer transition-colors duration-200 ml-1"
                >
                  hello@purecode.uk
                </a>
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Phone:</strong>{' '}
                <a
                  href="tel:01925357468"
                  className="text-teal-600 hover:text-teal-800 cursor-pointer transition-colors duration-200 ml-1"
                >
                  01925 357 468
                </a>
              </p>
              <p className="text-gray-700">
                <strong>Data Protection Officer:</strong>{' '}
                <a
                  href="mailto:dpo@purecode.uk"
                  className="text-teal-600 hover:text-teal-800 cursor-pointer transition-colors duration-200 ml-1"
                >
                  dpo@purecode.uk
                </a>
              </p>
            </div>

            {/* ... rest of existing content ... */}

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
